class LocalizationFormCustom extends HTMLElement {
  constructor() {
    super();
    this.utils = new Utils();
    this.elements = {
        inputCountry: this.querySelector('input[name="country_code"]'),
        inputLanguage: this.querySelector('input[name="locale_code"]'),
        button: this.querySelector('button'),
        form: this.querySelector('form'),
        panel: this.querySelector('.disclosure__list-wrapper'),
    };

    // Event listeners
    this.querySelector('button[type=submit]').addEventListener('click', this.onItemClick.bind(this));
    document.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    // Load saved preferences from cookies
    this.loadPreferencesFromCookies();
  }

  savePreferencesToCookies(language, country) {
    this.utils.setCookie('locale_code', language, 30); // Save for 30 days
    this.utils.setCookie('country_code', country, 30); // Save for 30 days
  }

  // Load preferences from cookies
  loadPreferencesFromCookies() {
    const savedLanguage = this.utils.getCookie('locale_code');
    const savedCountry = this.utils.getCookie('country_code');

    if (savedLanguage) {
      this.elements.inputLanguage.value = savedLanguage;
    }

    if (savedCountry) {
      this.elements.inputCountry.value = savedCountry;
    }
  }

  // Hide the selector panel
  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  // Handle ESC key to close the panel
  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
    this.hidePanel();
    event.stopPropagation();
    this.elements.button.focus();
  }

  // Handle item click (submit form and save preferences to cookies)
  onItemClick(event) {
    event.preventDefault();

    const selectedCountry = this.querySelector('.selectCountry')?.value || this.elements.inputCountry.value;
    const selectedLanguage = this.querySelector('.selectLanguage')?.value || this.elements.inputLanguage.value;

    // Save preferences to cookies
    this.savePreferencesToCookies(selectedLanguage, selectedCountry);

    // Set input values and submit form
    this.elements.inputCountry.value = selectedCountry;
    this.elements.inputLanguage.value = selectedLanguage;
    this.utils.setCookie('forceLocalization', true);
    if (this.elements.form) this.elements.form.submit();

  }

  // Close the selector if focus is lost
  closeSelector(event) {
    const isChild =
      this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
    if (!event.relatedTarget || !isChild) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form-custom', LocalizationFormCustom);


class CountryForm extends LocalizationFormCustom {
    constructor() {
      super();
    }

    connectedCallback() {
      this.checkCountry();
    }

    async checkCountry() {
      if (this.utils.getCookie('forceLocalization')) return

      const url = '/browsing_context_suggestions.json';
      const response = await fetch(url);
      const result = await response.json();

      const navigationCountry = result.detected_values.country
      if (navigationCountry.handle === this.dataset.userCountry) return

      const countrySpan = this.querySelector('[data-country]');
      countrySpan.innerText = navigationCountry.name.toUpperCase();

      this.querySelector('[data-continue]').addEventListener('click', (event) => {
        event.preventDefault();
        this.querySelector('.selectCountry').value = navigationCountry.handle;
        this.querySelector('button[type=submit]').click();
      });

      this.querySelector('.selectCountry').value = navigationCountry.handle;
      this.querySelector('.selectCountry').dispatchEvent(new Event('change', { bubbles: true }));

      publish(PUB_SUB_EVENTS.countryPopupOpen);

      this.querySelector('[data-change]').addEventListener('click', (event) => {
          this.onItemClick(event);
      })
    }
}

customElements.define('country-form', CountryForm);